import { render, staticRenderFns } from "./ControllersPage.vue?vue&type=template&id=2811e287&"
import script from "./ControllersPage.vue?vue&type=script&lang=js&"
export * from "./ControllersPage.vue?vue&type=script&lang=js&"
import style0 from "./ControllersPage.vue?vue&type=style&index=0&id=2811e287&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports